module.exports = __webpack_public_path__ + "static/joomla-ssl-00085b7015f749c212d3d155b5fae664.png";